// import React, { useContext } from "react";
// import { useState, useEffect } from "react";
// import Select from "react-select";
// import { Table, Button, Form, Pagination, Modal } from "react-bootstrap";
// import { Context } from "../../../../utils/context";
// import { getDownloadDataExcel, postData } from "../../../../utils/api";
// import { Link } from "react-router-dom";
// import {
//   formatDateTime,
//   formatDateToIST,
//   IDS,
//   OrderStatusIds,
//   ReturnStatusIds,
//   RoleId,
//   ServiceIds,
// } from "../../../../utils/common";
// import ProductModal from "../ProductModal";
// import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
// // import AssignOffCanvance from "../AssignDeliveryBoy";
// // import ProductModal from "../ProductModal";
// // import AssignReturnOffCanvance from "../AssignReturnDeliveryBoy";

// import DatePicker from "react-datepicker";
// import search1 from "../../../assets/icons/search.png";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { useForm } from "react-hook-form";
// import { ClipLoader } from "react-spinners";

// function PendingOrdersTable({
//   user,
//   OrderByOptions,
//   resultsPerPageOptions,
//   storeCategories,
//   vendorServices,
//   GetAllCounts,
// }) {
//   const {
//     getData,
//     editStatusData,
//     deleteData,
//     ErrorNotify,
//     isAllow,
//     Per_Page_Dropdown,
//     Select2Data,
//     usertype,
//     IMG_URL,
//   } = useContext(Context);

//   const [perPage, setperPage] = useState({
//     value: 25,
//     label: "Results per page: 25",
//   });

//   const [sortOrder, setSortOrder] = useState({
//     value: "DESC",
//     label: "Sort-by date (Descending)",
//   });

//   const [data, setData] = useState([]);
//   const [totalPages, settotalPages] = useState();
//   const [onPageChange, setonPageChange] = useState(1);
//   const [search, setSearch] = useState("");
//   const [searchCustomer, setSearchCustomer] = useState("");
//   const [searchCustomerContact, setSearchCustomerContact] = useState("");
//   const [resetdata, setReset] = useState();
//   const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [option, setOption] = useState();
//   const [hideFilter, setHideFilter] = useState(false);
//   const [storeCategory, setStoreCategory] = useState("");
//   const [productCategory, setProductCategory] = useState("");

//   const [loader, setLoader] = useState("");

//   const [searchDateTo, setSearchDateTo] = useState();
//   const [searchDateFrom, setSearchDateFrom] = useState();

//   const [searchStartTime, setSearchStartTime] = useState();
//   const [searchEndTime, setSearchEndTime] = useState();

//   const getDataAll = async () => {
//     setLoader(true);
//     const response = await getData(
//       `/admin/orders/product-order?page=${onPageChange || 1}&per_page=${
//         perPage?.value || 25
//       }&term=${search}&searchOrderStatus=${
//         OrderStatusIds.Processing || ""
//       }&storeCategory=${storeCategory}&productCategory=${
//         productCategory.value || ""
//       }&sortOrder=${sortOrder?.value || "DESC"}&from=${
//         searchDateFrom || ""
//       }&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
//         searchEndTime || ""
//       }&name=${search || ""}&customer=${searchCustomer || ""}&customer_contact=${searchCustomerContact || ""}`,
//     );
//     await setData(response);
//     setCurrentPage(response?.data?.current_page);
//     // setperPage(response?.data?.per_page);
//     settotalPages(response?.data?.total_pages);
//     setSearch(response?.data?.search_name);
//     setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
//     // await GetAllCounts();

//     setLoader(false);
//   };
//   useEffect(() => {
//     getDataAll();
//   }, [resetdata, searchOrderStatus, onPageChange]);

//   const handlePageChange = (pageNumber) => {
//     setonPageChange(pageNumber);
//   };

//   const paginationItems = [];
//   for (let page = 1; page <= totalPages; page++) {
//     paginationItems.push(
//       <Pagination.Item
//         key={page}
//         active={page === onPageChange}
//         onClick={() => handlePageChange(page)}
//       >
//         {page}
//       </Pagination.Item>,
//     );
//   }

//   const [showAssign, setShowAssign] = useState({ show: 0, data: {} });
//   const [showReturnAssign, setShowReturnAssign] = useState({
//     show: 0,
//     data: {},
//   });
//   const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

//   const customSelectStyles = {
//     control: (base) => ({
//       ...base,
//       borderRadius: "20px",
//       borderColor: "#ddd",
//       boxShadow: "none",
//       fontSize: "15px",
//       "&:hover": {
//         borderColor: "#aaa",
//       },
//     }),
//     dropdownIndicator: (base) => ({
//       ...base,
//       color: "#000",
//     }),
//     menu: (base) => ({
//       ...base,
//       borderRadius: "10px",
//       boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
//     }),
//     option: (base, state) => ({
//       ...base,
//       backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
//       color: "#000",
//       fontSize: "15px",
//       "&:hover": {
//         backgroundColor: "#eee",
//       },
//     }),
//   };

//   const ChangeOrderStatus = async (id, status_id) => {
//     try {
//       // Send the POST request to update the store's status
//       await postData(`/admin/orders/product-order/update-status/${id}`, {
//         order_status_id: status_id,
//       });

//       // Refresh the data after updating the store's status
//       await getDataAll();
//       await GetAllCounts();
//     } catch (error) {
//       console.error("Error updating store status:", error);
//     }
//   };

//   const downloadInvoice = async (invoiceUrl) => {
//     try {
//       const response = await fetch(invoiceUrl);
//       const blob = await response.blob();

//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");

//       link.href = url;
//       link.download = "invoice.pdf"; // Set your preferred filename
//       link.click();

//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Download error:", error);
//     }
//   };

//   // const HandleDownload = async () => {
//   //   if (data?.data?.data?.length <= 0) {
//   //     alert("No record found");
//   //   } else {
//   //     try {
//   //       await getDownloadDataExcel(
//   //         `/admin/orders/download?page=${onPageChange || 1}&per_page=${
//   //           perPage?.value || 25
//   //         }&term=${search}&searchOrderStatus=${
//   //           OrderStatusIds.Processing || ""
//   //         }&storeCategory=${storeCategory}&productCategory=${
//   //           productCategory.value || ""
//   //         }&sortOrder=${sortOrder?.value || "DESC"}&from=${
//   //           searchDateFrom || ""
//   //         }&to=${searchDateTo || ""}&start_time=${
//   //           searchStartTime || ""
//   //         }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
//   //           searchCustomer || ""
//   //         }`,
//   //         null,
//   //         "Order List",
//   //       );
//   //     } catch (error) {
//   //       console.error("Error:", error);
//   //     }
//   //   }
//   // };

//   const HandleDownload = async () => {
//     if (data?.data?.data?.length <= 0) {
//       alert("No record found");
//     } else {
//       try {
//         await getDownloadDataExcel(
//           `/admin/orders/download?page=${onPageChange || 1}&per_page=${
//             perPage?.value || 25
//           }&term=${search}&searchOrderStatus=${
//             OrderStatusIds.Processing || ""
//           }&storeCategory=${storeCategory}&productCategory=${
//             productCategory.value || ""
//           }&sortOrder=${sortOrder?.value || "DESC"}&from=${
//             searchDateFrom || ""
//           }&to=${searchDateTo || ""}&start_time=${
//             searchStartTime || ""
//           }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
//             searchCustomer || ""
//           }`,
//           null,
//           "Order List",
//         );
//       } catch (error) {
//         console.error("Error:", error);
//       }
//     }
//   };

//   const [product, setProduct] = useState([]);

//   const GetAllProduct = async () => {
//     const response = await getData("/common/masters/product");
//     if (response?.success) {
//       setProduct(await Select2Data(response?.data, "product_id"));
//     }
//   };

//   useEffect(() => {
//     GetAllProduct();
//   }, []);

//   return (
//     <section className="pending-table_holder">
//       <div className="quick-filters mt-3">
//         <span className="quick-filters__label">
//           <b>Quick Filters:</b>
//         </span>
//         <div className="quick-filters__tabs mt-3">
//           <div className="row align-items-end">
//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
//               <div className="num me-2">
//                 <label className="form-label">Start Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   placeholder="from"
//                   value={searchDateFrom}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     const year = value.split("-")[0];

//                     // Check if year has 4 digits
//                     if (year.length === 4 || value === "") {
//                       setSearchDateFrom(value);
//                       setonPageChange(1);
//                     }
//                   }}
//                 />
//               </div>
//             </div>

//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
//               <div className="num me-2">
//                 <label className="form-label">End Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   placeholder="to"
//                   value={searchDateTo}
//                   min={searchDateFrom || undefined}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     const year = value.split("-")[0];

//                     // Allow only if year is 4 digits or input is empty
//                     if (year.length === 4 || value === "") {
//                       setSearchDateTo(value);
//                       setonPageChange(1);
//                     }
//                   }}
//                 />
//               </div>
//             </div>

//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
//               <Form.Label>Select Product </Form.Label>
//               <Select
//                 isSearchable
//                 options={product}
//                 value={productCategory}
//                 placeholder="Select Product"
//                 onChange={(e) => {
//                   setProductCategory(e);
//                 }}
//                 classNamePrefix="searchProduct"
//               />
//             </div>
//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
//               <Form.Label>Customer Name</Form.Label>
//               <Form.Control
//                 placeholder="Enter Customer Name"
//                 type="text"
//                 className="form-control"
//                 id=""
//                 value={searchCustomer}
//                 onChange={(e) => {
//                   setSearchCustomer(e.target.value);
//                 }}
//               />
//             </div>

//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
//               <Form.Label>Customer Contact No</Form.Label>
//               <Form.Control
//                 placeholder="Enter Customer Contact No"
//                 type="text"
//                 className="form-control"
//                 id=""
//                 value={searchCustomerContact}
//                 onChange={(e) => {
//                   setSearchCustomerContact(e.target.value);
//                 }}
//               />
//             </div>
//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
//               <div className="Search me-2">
//                 <Button
//                   type="button"
//                   onClick={getDataAll}
//                   className="btn btn-search"
//                 >
//                   <img src={search1} className="search" alt="" />
//                 </Button>
//               </div>
//               <div className="Search-1">
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setSearch("");
//                     setSearchCustomerContact("");
//                     setSearchDateFrom("");
//                     setSearchDateTo("");
//                     setSearchEndTime("");
//                     setSearchStartTime("");
//                     setSearchCustomer("");
//                     setProductCategory("");
//                     setReset(!resetdata);
//                   }}
//                   className="btn btn-reset"
//                 >
//                   Reset
//                 </button>
//               </div>
//             </div>

//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
//               <button
//                 className="btn btn-success"
//                 type="button"
//                 onClick={HandleDownload}
//               >
//                 Download Excel
//                 <FontAwesomeIcon
//                   icon="fa-solid fa-file-lines"
//                   className="ms-2"
//                 />
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Table Section */}

//       {loader ? (
//         <>
//           <div className="text-center">
//             <ClipLoader />
//           </div>
//         </>
//       ) : (
//         <div className="pending-table ">
//           <Table striped bordered hover className="order-table" responsive>
//             <thead>
//               <tr>
//                 <th>Order Date</th>
//                 <th>Order details</th>

//                 <th>Products</th>
//                 <th>Total</th>
//                 <th>Delivery Details</th>
//                 <th>Order Status</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {data?.data?.data?.map((item, index) => (
//                 <tr key={index}>
//                   <td className="order-date">
//                     <div className="order-id">
//                       {formatDateTime(item?.createdAt)}
//                       {/* {item?.createdAt} */}
//                     </div>
//                     {/* <div className="order-info">
//                     <span>
//                       {new Date(item?.createdAt).toISOString().split("T")[0]}
//                     </span>
//                   </div> */}
//                     {/* <div className="order-info">
//                     <span>{formatTimeInIST(item?.createdAt)} IST</span>
//                   </div> */}
//                   </td>

//                   {/* Owner Details */}
//                   <td className="order-details">
//                     <div className="order-id text-highlight">
//                       {item?.invoice_no}
//                     </div>
//                     <div className="order-info">
//                       <span>
//                         <b>Buyer Name</b>
//                       </span>
//                     </div>
//                     <div className="order-info">
//                       <span className="text-highlight">{item?.User?.name}</span>
//                     </div>
//                     <div className="order-info">
//                       <span className="order-info">
//                         {item?.User?.contact_no}
//                       </span>
//                     </div>

//                     <div className="order-info">
//                       <span>
//                         <b>Payment Method :-</b>
//                       </span>{" "}
//                       <span>{item?.Payment_Method?.name}</span>
//                     </div>
//                   </td>

//                   <td className="order-details">
//                     {/* {item?.Product_Order_Details?.map((product) => (
//                     <>
//                       <div className="text-highlight">
//                         <span>
//                           <b>Product Name</b>
//                         </span>
//                         :<span>{product?.Product?.name}</span>
//                       </div>
//                       <div className="order-info">
//                         <span>
//                           <b>Category Name</b>
//                         </span>
//                         :<span>{product?.Product?.p_category?.name} </span>
//                       </div>
//                     </>
//                   ))} */}

//                     {item?.Product_Order_Details?.map(
//                       (product, productIndex) => (
//                         <React.Fragment key={product.id}>
//                           <div className="text-highlight">
//                             <strong>Product {productIndex + 1}</strong>
//                           </div>

//                           <div className="text-highlight">
//                             <span>
//                               <b>Product Name</b>
//                             </span>{" "}
//                             :<span>{product?.Product?.name}</span>
//                           </div>

//                           <div className="order-info">
//                             <span>
//                               <b>Category Name</b>
//                             </span>{" "}
//                             :<span>{product?.Product?.p_category?.name}</span>
//                           </div>

//                           <hr />
//                         </React.Fragment>
//                       ),
//                     )}
//                     <div></div>
//                     <div className=" mt-3">
//                       <Button
//                         className="action-btn active"
//                         onClick={() =>
//                           setShowDetails({
//                             show: item?.id,
//                             data: item?.Product_Order_Details,
//                           })
//                         }
//                       >
//                         View All Details
//                       </Button>
//                     </div>
//                   </td>

//                   <td className="order-details">
//                     <div className="order-id">
//                       <span>
//                         <b>Total SubTotal</b>
//                       </span>
//                     </div>
//                     <div className="order-info">
//                       <span>
//                         {item.Exchange_Rate?.symbol || "₹"}{" "}
//                         {Number(item?.total_selling_price).toFixed(2)} /-
//                       </span>
//                     </div>
//                     {/* <div className="order-id">
//                     <span>Packing Charges</span>
//                   </div>
//                   <div className="order-info">
//                     <span>{item?.packing_charges} /-</span>
//                   </div> */}
//                     <div className="order-id">
//                       <span>
//                         <b>Delivery Charges</b>
//                       </span>
//                     </div>
//                     <div className="order-info">
//                       <span>
//                         {" "}
//                         {item.Exchange_Rate?.symbol || "₹"}{" "}
//                         {Number(item?.delivery_charges).toFixed(2)} /-
//                       </span>
//                     </div>
//                     {/* <div className="order-id">
//                     <span>Offer Discount</span>
//                   </div>
//                   <div className="order-info">
//                     <span>{item?.total_offer_discount} /-</span>
//                   </div> */}
//                     <div className="order-id">
//                       <span>
//                         <b>Coupon Discount</b>
//                       </span>
//                     </div>
//                     <div className="order-info">
//                       <span>
//                         {" "}
//                         {item.Exchange_Rate?.symbol || "₹"}{" "}
//                         {Number(item?.total_coupon_discount).toFixed(2)} /-
//                       </span>
//                     </div>
//                     {/* <div className="order-id">
//                     <span>Refer Discount</span>
//                   </div>
//                   <div className="order-info">
//                     <span>{item?.refer_discount} /-</span>
//                   </div> */}
//                     <div className="order-id">
//                       <span>
//                         <b>Total Tax</b>
//                       </span>
//                     </div>
//                     <div className="order-info">
//                       <span>
//                         {" "}
//                         {item.Exchange_Rate?.symbol || "₹"}{" "}
//                         {Number(item?.total_tax).toFixed(2)} /-
//                       </span>
//                     </div>
//                     <div className="order-id">
//                       <span>
//                         <b>Grand Total</b>
//                       </span>
//                     </div>
//                     <div className="text-highlight">
//                       <span>
//                         {" "}
//                         {item.Exchange_Rate?.symbol || "₹"}{" "}
//                         {Number(item?.total_amount).toFixed(2)} /-
//                       </span>
//                     </div>
//                   </td>

//                   <td>
//                     <>
//                       <div className="text-highlight">
//                         <span>
//                           {[
//                             item?.User_Address?.first_name,
//                             item?.User_Address?.last_name,
//                           ]
//                             .filter(Boolean)
//                             .join(" ")}
//                         </span>
//                       </div>

//                       <div className="order-info">
//                         <span>
//                           {[
//                             item?.User_Address?.floor
//                               ? `${item.User_Address.floor} floor`
//                               : null,
//                             item?.User_Address?.building,
//                             item?.User_Address?.apartment,
//                             item?.User_Address?.street,
//                             item?.User_Address?.society,
//                             item?.User_Address?.area,
//                           ]
//                             .filter(Boolean)
//                             .join(", ")}
//                         </span>
//                       </div>

//                       <div className="order-info">
//                         <span>
//                           {[
//                             item?.User_Address?.Users_Address_Detail?.Country
//                               ?.name,
//                             item?.User_Address?.Users_Address_Detail?.State
//                               ?.name,
//                             item?.User_Address?.Users_Address_Detail?.City
//                               ?.name,
//                             item?.User_Address?.Users_Address_Detail?.Area
//                               ?.name,
//                             item?.User_Address?.Users_Address_Detail?.Pincode
//                               ?.name,
//                           ]
//                             .filter(Boolean)
//                             .join(", ")}
//                         </span>
//                       </div>

//                       {item?.User_Address?.address_type && (
//                         <div className="order-info">
//                           <span>{item.User_Address.address_type}</span>
//                         </div>
//                       )}

//                       {item?.User_Address?.contact_no && (
//                         <div className="text-highlight">
//                           <span>{item.User_Address.contact_no}</span>
//                         </div>
//                       )}
//                     </>
//                   </td>

//                   <td>
//                     {item?.order_status_id === 4 ? (
//                       <div>
//                         <p className="status-holder shipped">
//                           {item?.Order_status?.name}
//                         </p>
//                       </div>
//                     ) : (
//                       <div>
//                         <p className="status-holder Unshipped">
//                           <b>{item?.Order_status?.name}</b>
//                         </p>
//                       </div>
//                     )}
//                   </td>

//                   <td>
//                     <div className="my-1">
//                       <Button
//                         className="action-btn active"
//                         onClick={() =>
//                           ChangeOrderStatus(item?.id, OrderStatusIds.Preparing)
//                         }
//                       >
//                         {" "}
//                         Send Preparing Order{" "}
//                       </Button>
//                     </div>

//                     <div className="my-1">
//                       <Button
//                         className="action-btn"
//                         onClick={() => downloadInvoice(IMG_URL + item?.invoice)}
//                       >
//                         Print Invoice
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//           {data && data?.data?.data?.length > 0 ? (
//             <Pagination_Holder
//               onPageChange={currentPage}
//               totalPages={totalPages}
//               handlePageChange={handlePageChange}
//             />
//           ) : (
//             <p className="no-datashow">Sorry, No Data Found</p>
//           )}
//         </div>
//       )}

//       <ProductModal
//         handleClose={() => {
//           setShowDetails({ show: 0, data: {} });
//         }}
//         setShow={() => setShowDetails({ show: 0, data: {} })}
//         show={showDetails?.show}
//         data={showDetails?.data}
//       />
//       {/* Modal */}
//     </section>
//   );
// }

// export default PendingOrdersTable;

import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { Table, Button, Form, Pagination } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { getDownloadDataExcel, postData } from "../../../../utils/api";
import { Link } from "react-router-dom";
import {
  formatDateToIST,
  IDS,
  OrderStatusIds,
  PaymentMethods,
  ReturnStatusIds,
  RoleId,
  ServiceIds,
} from "../../../../utils/common";
import ProductModal from "../ProductModal";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
// import AssignOffCanvance from "../AssignDeliveryBoy";
// import ProductModal from "../ProductModal";
// import AssignReturnOffCanvance from "../AssignReturnDeliveryBoy";

import DatePicker from "react-datepicker";
import search1 from "../../../assets/icons/search.png";
// import Loader from "../../../common/Loader/Loader";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalSave from "../../../common/ModelSave";
function PendingOrdersTable({
  user,
  OrderByOptions,
  resultsPerPageOptions,
  storeCategories,
  vendorServices,
  GetAllCounts,
}) {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
  } = useContext(Context);

  const [perPage, setperPage] = useState({
    value: 25,
    label: "Results per page: 25",
  });

  const [sortOrder, setSortOrder] = useState({
    value: "DESC",
    label: "Sort-by date (Descending)",
  });

  const [data, setData] = useState([]);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [search, setSearch] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchCustomerContact, setSearchCustomerContact] = useState("");
  const [reset, setReset] = useState();
  const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [option, setOption] = useState();
  const [hideFilter, setHideFilter] = useState(false);
  const [storeCategory, setStoreCategory] = useState("");
  const [productCategory, setProductCategory] = useState("");

  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const [searchStartTime, setSearchStartTime] = useState();
  const [searchEndTime, setSearchEndTime] = useState();
  const [loading, setLoading] = useState(false);

  const getDataAll = async () => {
    setLoading(true);

    const response = await getData(
      `/admin/orders/product-order?page=${onPageChange || 1}&per_page=${
        perPage?.value || 25
      }&term=${search}&searchOrderStatus=${
        OrderStatusIds.Processing || ""
      }&storeCategory=${storeCategory}&productCategory=${
        productCategory.value || ""
      }&sortOrder=${sortOrder?.value || "DESC"}&from=${
        searchDateFrom || ""
      }&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
        searchEndTime || ""
      }&name=${search || ""}&customer=${searchCustomer || ""}&customer_contact=${searchCustomerContact || ""}`,
    );
    await setData(response);

    if (response?.success) {
      setLoading(false);
    }
    setCurrentPage(response?.data?.current_page);
    // setperPage(response?.data?.per_page);
    settotalPages(response?.data?.total_pages);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    // await GetAllCounts();
  };
  useEffect(() => {
    getDataAll();
  }, [reset, searchOrderStatus, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const [showAssign, setShowAssign] = useState({ show: 0, data: {} });
  const [showReturnAssign, setShowReturnAssign] = useState({
    show: 0,
    data: {},
  });
  const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "20px",
      borderColor: "#ddd",
      boxShadow: "none",
      fontSize: "15px",
      "&:hover": {
        borderColor: "#aaa",
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#000",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: "#eee",
      },
    }),
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const ChangeOrderStatus = async (id, status_id) => {
    try {
      // Send the POST request to update the store's status
      const response = await postData(
        `/admin/orders/product-order/update-status/${id}`,
        {
          order_status_id: status_id,
        },
      );

      if (response?.success) {
        await setShowModal({
          code: response.code,
          message: response.data || response.message,
        });
        await getDataAll();
        await GetAllCounts();
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }

      setTimeout(() => {
        setShowModal(0);
      }, 1000);
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  const downloadInvoice = async (invoiceUrl) => {
    try {
      const response = await fetch(invoiceUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "invoice.pdf"; // Set your preferred filename
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        await getDownloadDataExcel(
          `/admin/orders/download?page=${onPageChange || 1}&per_page=${
            perPage?.value || 25
          }&term=${search}&searchOrderStatus=${
            OrderStatusIds.Processing || ""
          }&storeCategory=${storeCategory}&productCategory=${
            productCategory.value || ""
          }&sortOrder=${sortOrder?.value || "DESC"}&from=${
            searchDateFrom || ""
          }&to=${searchDateTo || ""}&start_time=${
            searchStartTime || ""
          }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
            searchCustomer || ""
          }`,
          null,
          "Order List",
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");
    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  return (
    <section className="pending-table_holder">
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row align-items-end mb-3">
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div className="num me-2 ">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  min="1900-01-01"
                  max="2099-12-31"
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Check if year has 4 digits
                    if (year.length === 4 || value === "") {
                      setSearchDateFrom(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div className="num me-2">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  min={searchDateFrom}
                  max="2099-12-31"
                  value={searchDateTo}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Allow only if year is 4 digits or input is empty
                    if (year.length === 4 || value === "") {
                      setSearchDateTo(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Select Product </Form.Label>
              <Select
                isSearchable
                options={product}
                value={productCategory}
                placeholder="Select Product"
                onChange={(e) => {
                  setProductCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div>
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                placeholder="Enter Customer Name"
                type="text"
                className="form-control"
                id=""
                value={searchCustomer}
                onChange={(e) => {
                  setSearchCustomer(e.target.value);
                }}
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Customer Contact No</Form.Label>
              <Form.Control
                placeholder="Enter Customer Contact No"
                type="text"
                className="form-control"
                id=""
                value={searchCustomerContact}
                onChange={(e) => {
                  setSearchCustomerContact(e.target.value);
                }}
              />
            </div>
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
              <div className="Search me-2">
                <Button
                  type="button"
                  onClick={getDataAll}
                  className="btn btn-search"
                >
                  Search
                </Button>
              </div>
              <div className="Search-1">
                <button
                  type="button"
                  onClick={() => {
                    setSearch("");
                    setSearchCustomerContact("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setSearchEndTime("");
                    setSearchStartTime("");
                    setSearchCustomer("");
                    setProductCategory("");
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div>
                <button
                  className="btn btn-success mt-2"
                  type="button"
                  onClick={HandleDownload}
                >
                  Download Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div>
          <strong>Total Order:</strong>
          {data?.data?.data?.length}
        </div>
        <div>
          <strong>Total Amount:</strong> ₹
          {Number(data?.data?.total_selling_value || 0).toFixed(2)}
        </div>
        <div>
          <strong>Average Amount:</strong> ₹
          {Number(data?.data?.average_selling_value || 0).toFixed(2)}
        </div>
        {/* <div>
          <strong>Total Kg:</strong>{" "}
          {Number(data?.data?.total_weight || 0).toFixed(2)} kg
        </div> */}
      </div>

      {/* Table Section */}
      <div className="pending-table mt-3">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Order Date</th>
              <th>Order details</th>
              <th>Products</th>
              {/* Increased width for Total column */}
              <th style={{ width: "220px" }}>Total</th>
              {/* Reduced width for Delivery Details column */}
              <th style={{ width: "300px" }}>Delivery Details</th>
              <th>Order Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8" className="text-center py-5">
                  <div className="d-flex justify-content-center align-items-center">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                      style={{ width: "3rem", height: "3rem" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>

                  <div className="mt-2">Loading orders...</div>
                </td>
              </tr>
            ) : (
              data?.data?.data?.map((item, index) => (
                <tr key={index}>
                  <td className="order-details">{index + 1}</td>
                  <td className="order-date">
                    <div className="order-id">
                      {formatDateToIST(item?.createdAt)}
                      {/* {item?.createdAt} */}
                    </div>
                    {/* <div className="order-info">
                    <span>
                      {new Date(item?.createdAt).toISOString().split("T")[0]}
                    </span>
                  </div> */}
                    {/* <div className="order-info">
                    <span>{formatTimeInIST(item?.createdAt)} IST</span>
                  </div> */}
                  </td>

                  {/* Owner Details */}
                  <td className="order-details">
                    <div className="order-id text-highlight">
                      {item?.invoice_no}
                    </div>
                    <div className="order-info"></div>
                    <div className="order-info">
                      <span>
                        <b>Buyer Name :</b>
                      </span>
                      <span className="text-highlight">{item?.User?.name}</span>
                    </div>
                    <div className="order-info">
                      <span>
                        <b>Buyer Contact No:</b>
                      </span>
                      <span className="order-info">
                        {item?.User?.contact_no}
                      </span>
                    </div>

                    <div className="order-info">
                      <span>
                        <b>Payment Method :</b>
                      </span>
                      <span>{item?.Payment_Method?.name}</span>
                    </div>
                    {Number(item?.Payment_Method?.id) ===
                      Number(PaymentMethods.Online) && (
                      <div className="order-info">
                        <span>
                          <b>Payment Id </b>
                        </span>
                        <span>{item?.Order_Payment_Detail?.payment_id}</span>
                      </div>
                    )}
                  </td>

                  <td className="order-details">
                    {item?.Product_Order_Details?.map((product, index) => (
                      <>
                        <div className="index_div">
                          <p className="index_no"> {index + 1})</p>
                          <div className="all_data">
                            <div className="text-highlight">
                              <span>
                                <b>Product Name </b>
                              </span>
                              :<span> {product?.Product?.name}</span>
                            </div>
                            <div className="order-info">
                              <span>
                                <b>Category Name </b>
                              </span>
                              :
                              <span>
                                {" "}
                                {product?.Product?.p_category?.name}{" "}
                              </span>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                    <div></div>
                    <div className=" mt-3">
                      <Button
                        className="action-btn active"
                        onClick={() =>
                          setShowDetails({
                            show: item?.id,
                            data: item?.Product_Order_Details,
                          })
                        }
                      >
                        View All Details
                      </Button>
                    </div>
                  </td>

                  <td className="order-details more_space">
                    <div className="order-id">
                      <span>
                        <b>Total SubTotal</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_selling_price).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Packing Charges</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.packing_charges} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b>Delivery Charges</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.delivery_charges).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Offer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.total_offer_discount} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b>Coupon Discount</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_coupon_discount).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Refer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.refer_discount} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b>Total Tax</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_tax).toFixed(2)} /-
                      </span>
                    </div>
                    <div className="order-id">
                      <span>
                        <b>Grand Total</b>
                      </span>
                    </div>
                    <div className="text-highlight">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_amount).toFixed(2)} /-
                      </span>
                    </div>
                  </td>

                  <td>
                    <>
                      <div className="text-highlight">
                        <span>
                          {item?.User_Address?.first_name}{" "}
                          {item?.User_Address?.last_name}
                        </span>
                      </div>
                      <div className="order-info">
                        <span>{item?.User_Address?.floor} floor ,</span>
                        <span>{item?.User_Address?.building}, </span>
                        <span>{item?.User_Address?.apartment} ,</span>
                        <span>{item?.User_Address?.street}, </span>
                        <span>{item?.User_Address?.direction}, </span>
                      </div>
                      <div className="order-info">
                        <span>
                          {
                            item?.User_Address?.Users_Address_Detail?.Country
                              ?.name
                          }{" "}
                          ,
                        </span>
                        <span>
                          {
                            item?.User_Address?.Users_Address_Detail?.State
                              ?.name
                          }
                          ,{" "}
                        </span>
                        <span>
                          {item?.User_Address?.Users_Address_Detail?.City?.name}{" "}
                          ,
                        </span>
                        <span>
                          {item?.User_Address?.Users_Address_Detail?.Area?.name}
                          ,{" "}
                        </span>
                        <span>
                          {
                            item?.User_Address?.Users_Address_Detail?.Pincode
                              ?.name
                          }
                          ,{" "}
                        </span>
                      </div>
                      <div className="order-info">
                        <span>{item?.User_Address?.address_type}</span>
                      </div>
                      <div className="text-highlight">
                        <span>{item?.User_Address?.contact_no} </span>
                      </div>
                    </>
                  </td>

                  <td>
                    {item?.order_status_id === 4 ? (
                      <div>
                        <p className="status-holder shipped">
                          {item?.Order_status?.name}
                        </p>
                      </div>
                    ) : (
                      <div>
                        <p className="status-holder Unshipped">
                          <b>{item?.Order_status?.name}</b>
                        </p>
                      </div>
                    )}
                  </td>

                  <td>
                    <div className="my-1">
                      <Button
                        className="action-btn active"
                        onClick={() =>
                          ChangeOrderStatus(item?.id, OrderStatusIds.Preparing)
                        }
                      >
                        {" "}
                        Send Preparing Order{" "}
                      </Button>
                    </div>

                    <div className="my-1">
                      <Button
                        className="action-btn"
                        onClick={() => downloadInvoice(IMG_URL + item?.invoice)}
                      >
                        Print Invoice
                      </Button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
        {data && data?.data?.data?.length > 0 ? (
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        ) : (
          <p className="no-datashow">Sorry, No Data Found</p>
        )}
      </div>

      <ProductModal
        handleClose={() => {
          setShowDetails({ show: 0, data: {} });
        }}
        setShow={() => setShowDetails({ show: 0, data: {} })}
        show={showDetails?.show}
        data={showDetails?.data}
      />

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </section>
  );
}

export default PendingOrdersTable;
